import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock, Sparkles } from "lucide-react";
import { api, setAuthToken, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAuthToken(data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-white p-8 shadow-2xl" data-testid="admin-login-card">
        <div className="mb-6 flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-700 text-white"><Sparkles size={18} /></span>
          <span className="font-display text-lg font-extrabold text-slate-900">GoCleaning — Admin</span>
        </div>
        <h1 className="font-display text-2xl font-black text-slate-900">Sign in</h1>
        <p className="mt-1 text-sm text-slate-500">Access your leads dashboard.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="text-sm font-semibold text-slate-700">Email</Label>
            <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12 rounded-xl" placeholder="admin@email.com" />
          </div>
          <div>
            <Label className="text-sm font-semibold text-slate-700">Password</Label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12 rounded-xl" placeholder="••••••••" />
          </div>
          {error && <p className="text-sm text-red-500" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-btn"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-emerald-700 py-3.5 font-bold text-white transition-colors hover:bg-emerald-800 disabled:opacity-60">
            {loading ? <Loader2 size={18} className="animate-spin" /> : <Lock size={16} />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
